module.exports = __webpack_public_path__ + "img/ic_price_black_usd.35a52271.svg";